import React from 'react';
import { IMaskInput } from 'react-imask';
import { FormWrapper, InputWrapper } from './Wrappers';

/*
function isValidLuhnOld_AM_I_EQUIVALENT_TO_THE_ABOVE_FUNCTION(str: string){
  var x = str.replace('-', '');
  return !/^\d+$/.test(x) || (x.split('').reduce(function(sum, d, n){ 
    return sum + parseInt(((n + x.length) %2)? d: [0,2,4,6,8,1,3,5,7,9][d]);
    }, 0)) % 10 == 0;
}
*/

function isValidLuhn(str: string){
  var x = str.replace('-', '');
  return !/^\d+$/.test(x) || (x.split('').reduce(function(sum, d, n){ 
    return sum + (((n + x.length) %2) ? parseInt(d) : [0,2,4,6,8,1,3,5,7,9][parseInt(d)]);
    }, 0)) % 10 == 0;
}

export function isValidGiro(giro: string) {
  var g = giro.replace(/\s/g, '');
  if (/^([0-9]{1,7})\-[0-9]$/.test(g)) {
    return isValidLuhn(g); // plusgiro
  } else if (/^([0-9]{3,4})\-[0-9]{4}$/.test(g)) {
    return isValidLuhn(g); // bankgiro
  }
  return false;
}

function GiroInputRaw({onChange, ...props}: {onChange?: (newValue: string) => void}) {
  return (
    <IMaskInput
      {...props}
      mask="prefix{`-}suffix"
      blocks={{
        prefix: {
          mask: '0[000000]'
        },
        suffix: {
          mask: '0[000]'
        }
      }}
      lazy={true}
      overwrite='shift'
      eager={false}
      unmask={false}
      autoComplete='off'
      onAccept={(value, _mask, event) => {if (event !== undefined && onChange !== undefined) { onChange(value) }}}
    />
  )
}

// TODO: Add memo here?
const GiroInput = FormWrapper({Component: InputWrapper(GiroInputRaw), validationFunction: isValidGiro})

export default GiroInput
